import {Button, Input} from "antd";
import config from "../api/config";
import BundledEditor from "../components/BundledEditor";
import React, {useEffect} from "react";

const CourseDescriptionTab = ({index, title, content, onChange}) => {

    const [formTitle, setFormTitle] = React.useState('');
    const [formText, setFormText] = React.useState('');
    const editorRef = React.useRef(null);
    const [ editor, setEditor ] = React.useState(null);

    const onFormChange = () => {
        let description = 'new';
        if (editor && editor.current) {
            description = editor.current.getContent();
        }
        onChange(index, formTitle, description);
    }

    useEffect(() => {
        setFormTitle(title);
        setFormText(content);
        if (editor && editor.current) {
            editor.current.setContent(content);
        }
    }, [index]);

    React.useEffect(() => {
        setEditor(editorRef);
    }, [])

    return <>
        <Input value={formTitle} onChange={(e) => setFormTitle(e.target.value)}/>
        <div className={'mt-4'}>
            <BundledEditor
                onInit={(_evt, editor) => editorRef.current = editor}
                initialValue={formText}
                init={{
                    height: 500,
                    menubar: false,
                    images_upload_url: config.host + '/api/editor/file',
                    plugins: [
                        'advlist', 'anchor', 'autolink', 'help', 'image', 'link', 'lists',
                        'searchreplace', 'table', 'wordcount'
                    ],
                    toolbar: 'undo redo | blocks | image ' +
                        'bold italic forecolor | alignleft aligncenter ' +
                        'alignright alignjustify | bullist numlist outdent indent | ' +
                        'removeformat | help',
                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                }}
            />
        </div>
        <div className={'mt-4'}>
            <Button type={'primary'} onClick={onFormChange}>Изменить</Button>
        </div>
    </>
}

export default CourseDescriptionTab;
